export const CLEAR_BTN_TEXT = 'Clear';
export const SHOW_PASSWORD = 'Show password';
export const HIDE_PASSWORD = 'Hide password';
export const TEXT_AREA_LABEL_SPACE_MAX_SIZE = 100;
export const TEXT_AREA_LABEL_SPACE_NORMAL_SIZE = 40;
export const TEXT_AREA_LABEL_SPACE_MID_SIZE = 70;
export const BUTTON_SWITCH_TOGGLE = 'button-switch__toggle';
export const BUTTON_SWITCH_TOGGLE_LABEL = 'button-switch__label';
export const CLASSNAME_DROPDOWN_ICON = 'mi-icon-add-filled-circle';
export const COLON_SYMBOL = ':';
export const HOURS = 'hours';
export const MINUTES = 'minutes';
export const SECONDS = 'seconds';
export const FIRST_POSITION = 'firstPosition';
export const SECOND_POSITION = 'secondPosition';
export const DEFAULT_TIME = '00:00:00';
export const TIME_OF_DAY_AM = 'AM';
export const TIME_OF_DAY_PM = 'PM';
export const ARROW_LEFT = 'ArrowLeft';
export const ARROW_RIGHT = 'ArrowRight';
export const ARROW_UP = 'ArrowUp';
export const ARROW_DOWN = 'ArrowDown';
export const TIME_OF_DAY = 'timeOfDay';
export const MINUTES_STARTING_POSITION = 3;
export const SECONDS_STARTING_POSITION = 6;
export const TIME_OF_DAY_STARTING_POSITION = 9;
export const END_POSITION_VALUE = 2;
export const TIME_INPUT_REGEX = /^[0-9]$/;
export const MAX_SECOND_DIGIT = 9;
//# sourceMappingURL=InputConstant.js.map